import { connect } from 'react-redux';
import { isVenueDashboardSubtypeFoodAndBeverage } from 'helpers/ia-logic';
import { selectActiveVenue } from 'selectors/general';
import { selectIsMobile } from 'selectors/ui';
import { fetchReviewsData, reportReviewAsAbuse, deleteStudioReply } from '../Ratings.saga';
import {
  selectReviewsGroupedByWeek,
  selectHasMore,
  isReviewsLoading,
  isAnyFilterSelected,
  selectShouldRefreshRatingsList,
} from '../Ratings.selectors';
import RatingsList from './RatingsList';

const mapStateToProps = state => ({
  groupedReviews: selectReviewsGroupedByWeek(state),
  hasMore: selectHasMore(state),
  isLoading: isReviewsLoading(state),
  isMobile: selectIsMobile(state),
  hasActiveFilters: isAnyFilterSelected(state),
  shouldRefreshRatingsList: selectShouldRefreshRatingsList(state),
  isVenueFoodAndBeverage: isVenueDashboardSubtypeFoodAndBeverage(selectActiveVenue(state)),
});

const mapDispatchToProps = {
  fetchReviewsData,
  reportReviewAsAbuse,
  deleteStudioReply,
};
export default connect(mapStateToProps, mapDispatchToProps)(RatingsList);
